export const heroData = {
  title: "Oleh Hubskiy",
  subTitle: "I am a Full Stack Developer",
  heroDescription: ` I'm a full-stack developer from Ukraine, with a burning passion and a
        great desire to improve my programming skills.
        `,
};

/* My dedication to work and
        eagerness to learn constantly make me ready for new projects and
        challenges. */
